import React from 'react';
import PropTypes from 'prop-types';
import dig from 'spiceutils/dist/dig';

import { ChartResult, Container, Form } from 'containers/DatatoolSlim';
import Section from 'components/Section';

import CdfRadioButtons from '../../components/FormControls/CdfRadioButtons';
import AnswersToShow from '../../components/FormControls/AnswersToShow';
import Country from '../../components/FormControls/Country';
import BreakGroupBreakAnswer from '../../components/FormControls/BreakGroup_BreakAnswer';
import TrueFalseNoneSelect from '../../components/FormControls/TrueFalseNoneSelect';
import CountryList from '../../components/FormControls/CountryList';
import BreakList from '../../components/FormControls/BreakList';
import SurveyList from '../../components/FormControls/SurveyList';
import YearsToShow from '../../components/FormControls/YearsToShow';
import IncludeBacksheets from '../../components/FormControls/IncludeBacksheets';
import BacksheetCountries from '../../components/FormControls/BacksheetCountries';

import Chart from '../../components/Chart';
import DownloadNotification from '../../components/DownloadNotifications';

// Advanced components
import CdfEditor from '../../components/FormControls/CdfEditor';
import SampleThreshold from '../../components/FormControls/SampleThreshold';

const DatatoolSlim = (props) => (
  <Container>
    <Form>
      <h3>Configure Chart</h3>
      <Section title="Filters" initialOpen>
        <Country controlList={props.controlList} cdf={props.cdf} updateCDF={props.updateCDF} />
        <CountryList cdf={props.cdf} controlList={props.controlList} updateCDF={props.updateCDF} />
        <BreakList cdf={props.cdf} controlList={props.controlList} updateCDF={props.updateCDF} />
        <BreakGroupBreakAnswer controlList={props.controlList} cdf={props.cdf} updateCDF={props.updateCDF} />
      </Section>
      <Section title="Advanced">
        <AnswersToShow controlList={props.controlList} cdf={props.cdf} updateCDF={props.updateCDF} />
        <CdfRadioButtons type="Adjusted" label="Adjusted" options={[{ value: undefined, text: 'Default' }, { value: true, text: 'Adjusted' }, { value: false, text: 'Reported' }]} cdf={props.cdf} updateCDF={props.updateCDF} controlList={props.controlList} />
        <CdfRadioButtons
          type="AgeFilter"
          label="Age filter"
          options={dig(
            props.controlList,
            'AgeFilter',
            'Options',
            {
              map: (text, index) => ({
                text,
                value: [undefined, 'All', '16-64'][index],
              }),
            }
          ) || []}
          cdf={props.cdf}
          updateCDF={props.updateCDF}
          controlList={props.controlList}
        />
        <SampleThreshold type="LowSampleThreshold" controlList={props.controlList} updateCDF={props.updateCDF} cdf={props.cdf} />
        <SampleThreshold type="NoSampleThreshold" controlList={props.controlList} updateCDF={props.updateCDF} cdf={props.cdf} />
        <TrueFalseNoneSelect type="Rebase" updateCDF={props.updateCDF} cdf={props.cdf} controlList={props.controlList} />
        <TrueFalseNoneSelect type="ShowMissingValues" updateCDF={props.updateCDF} cdf={props.cdf} controlList={props.controlList} />
        <TrueFalseNoneSelect type="CalculatedMissingValues" updateCDF={props.updateCDF} cdf={props.cdf} controlList={props.controlList} />
      </Section>
      <Section title="Survey">
        <YearsToShow cdf={props.cdf} updateCDF={props.updateCDF} controlList={props.controlList} />
        <SurveyList cdf={props.cdf} updateCDF={props.updateCDF} controlList={props.controlList} />
      </Section>
      <Section title="PPTX">
        <IncludeBacksheets cdf={props.cdf} updateCDF={props.updateCDF} controlList={props.controlList} />
        <BacksheetCountries cdf={props.cdf} updateCDF={props.updateCDF} controlList={props.controlList} />
      </Section>
      <Section title="CDF">
        <CdfEditor cdf={props.cdf} controlList={props.controlList} />
      </Section>
    </Form>
    <ChartResult>
      <Chart updateCDF={props.updateCDF} cdf={props.cdf} />
    </ChartResult>
    <DownloadNotification />
  </Container>
);

DatatoolSlim.propTypes = {
  controlList: PropTypes.object.isRequired,
  cdf: PropTypes.object.isRequired,
  updateCDF: PropTypes.func.isRequired,
};

export default DatatoolSlim;



// WEBPACK FOOTER //
// ./app/containers/DatatoolAdvanced/index.js